import { Card, CardBody, Center, Text } from "@chakra-ui/react";
import { SystemStyleObject } from "@chakra-ui/styled-system";
import { useUploady } from "@rpldy/uploady";
import React from "react";
import { DropzoneOptions, FileRejection, useDropzone } from "react-dropzone";
import { Trans, useTranslation } from "react-i18next";
import { useToast } from "shared/components/toast/useToast";
import { UploadIcon } from "shared/icons/UploadIcon";
import { FeaturedIcon } from "shared/icons/wrappers/FeaturedIcon";

export const FileUploadDropZone: React.FC<{
  options?: DropzoneOptions;
}> = ({ options }) => {
  const { t } = useTranslation(["common"]);
  const { showErrorToast } = useToast();

  const { upload } = useUploady();

  const onDropAccepted = (acceptedFiles: File[]) => {
    upload(acceptedFiles);
  };

  const onDropRejected = (fileRejections: FileRejection[]) => {
    showErrorToast(
      fileRejections[0].errors
        .map((file_error) => file_error.message)
        .toString(),
    );
  };

  const { getRootProps, isDragAccept, isDragReject } = useDropzone({
    ...options,
    onDropAccepted,
    onDropRejected,
  });

  return (
    <Card
      cursor="pointer"
      _active={{
        bg: "gray.25",
      }}
      sx={{
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {}),
      }}
      {...getRootProps()}
    >
      <CardBody textAlign="center">
        <Center mb="12px">
          <FeaturedIcon>
            <UploadIcon width="24px" height="24px" color="gray.600" />
          </FeaturedIcon>
        </Center>
        <Text color="gray.500">
          <Trans ns="common" i18nKey="upload.instructions">
            <Text as="span" textStyle="bodyBold" color="gray.900">
              Click to upload
            </Text>
            or drag and drop
          </Trans>
        </Text>
        {options?.accept && (
          <Text textColor="gray.500">
            {t("common:upload.requirements", {
              extensions: [...new Set(Object.values(options.accept).flat())],
            })}
          </Text>
        )}
      </CardBody>
    </Card>
  );
};

const acceptStyle: SystemStyleObject = {
  bg: "primary.100",
};
const rejectStyle: SystemStyleObject = {
  bg: "error.100",
};
